import React from 'react';
import { Download, Heart, ArrowUp } from 'lucide-react';
import { profileData } from '../data/mockData';
import { Button } from './ui/button';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const scrollToTop = () => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const footerLinks = [
    { name: 'About', href: '#about' },
    { name: 'Skills', href: '#skills' },
    { name: 'Experience', href: '#experience' },
    { name: 'Projects', href: '#projects' },
    { name: 'Education', href: '#education' },
    { name: 'Contact', href: '#contact' }
  ];

  return (
    <footer className="bg-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        {/* Main Footer */}
        <div className="py-12 grid md:grid-cols-3 gap-8 items-center">
          {/* Logo & Description */}
          <div>
            <a href="#" className="text-2xl font-bold">
              <span className="text-emerald-400">K</span>ailash Kumar
            </a>
            <p className="text-gray-400 mt-3 text-sm leading-relaxed">
              Software Engineer specializing in React Native, React Js, and full-stack development.
            </p>
          </div>

          {/* Quick Links */}
          <div className="flex flex-wrap justify-center gap-x-6 gap-y-2">
            {footerLinks.map((link) => (
              <a
                key={link.name}
                href={link.href}
                className="text-sm text-gray-400 hover:text-white transition-colors"
              >
                {link.name}
              </a>
            ))}
          </div>

          {/* Download CV */}
          <div className="flex justify-end">
            <a href={profileData.cvUrl} download="Kailash_Kumar_CV.pdf">
              <Button
                variant="outline"
                className="border-emerald-500 text-emerald-400 hover:bg-emerald-500 hover:text-white"
              >
                <Download className="w-4 h-4 mr-2" />
                Download CV
              </Button>
            </a>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="py-6 border-t border-gray-800 flex flex-col sm:flex-row justify-between items-center space-y-4 sm:space-y-0">
          <p className="text-sm text-gray-400 flex items-center">
            © {currentYear} Kailash Kumar. Made with{' '}
            <Heart className="w-4 h-4 mx-1 text-red-500 fill-current" />{' '}
            in India
          </p>

          {/* Back to Top */}
          <button
            onClick={scrollToTop}
            className="flex items-center text-sm text-gray-400 hover:text-white transition-colors group"
          >
            Back to top
            <ArrowUp className="w-4 h-4 ml-1 group-hover:-translate-y-1 transition-transform" />
          </button>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
